import React from 'react';
import { useTranslation } from 'react-i18next';
import IconButton from '@mui/material/IconButton';
import PasteIcon from '@mui/icons-material/FileCopy';
import Tooltip from '@mui/material/Tooltip';
import InputAdornment from '@mui/material/InputAdornment';

function copyToClipboard(inputId: string) {
    const copyText = document.getElementById(inputId);
    /* Select the text field */
    // @ts-expect-error [TS migration] (previously $FlowFixMe)
    copyText.select();
    /* Copy the text inside the text field */
    document.execCommand('copy');
}

function CopyButtonAdornment({ inputId }: { inputId: string }) {
    const { t } = useTranslation();
    return (
        <InputAdornment position="start">
            <Tooltip title={t('common.copy')}>
                <IconButton
                    onClick={() => {
                        copyToClipboard(inputId);
                    }}
                    size="large"
                >
                    <PasteIcon sx={{ color: 'primary.main' }} />
                </IconButton>
            </Tooltip>
        </InputAdornment>
    );
}
export default CopyButtonAdornment;
